import React from "react";
import { imageBasePath } from "../../Utils/config";

const Resources = () => {
  return (
    <div className="h-full">
      <div className="flex flex-col justify-center items-center">
        <img src={imageBasePath + "resource1.png"} alt={"Resource"} />
      </div>
    </div>
  );
};

export default Resources;
